export default __webpack_public_path__ + "static/media/coin4.09b8568a.png";